/** @jsx jsx */
import { GatsbyImage } from 'gatsby-plugin-image'
import PropTypes from 'prop-types'
import { Box, Container, Grid, Heading, jsx, Text } from 'theme-ui'

const PageHeadingImageSection = ({
  cta,
  description,
  footer,
  image,
  subtitle,
  title,
}) => {
  return (
    <Box
      pt={[5, 7, 9]}
      pb={[7, 8, 10]}
      sx={{ overflow: 'hidden' }}
      bg="backgroundMedium"
    >
      <Container sx={{ position: 'relative', zIndex: '1' }}>
        <img
          src="/images/backgrounds/page-heading-image-blob.svg"
          alt=""
          aria-hidden="true"
          sx={{
            height: ['342px', '1086px'],
            left: ['-196px', '-600px', '-432px', '-480px'],
            pointerEvents: 'none',
            position: 'absolute',
            top: ['8px', '16px', '64px'],
            width: ['300px', '953px'],
            zIndex: '-1',
          }}
        />
        <Box sx={{ textAlign: 'center' }}>
          <Heading as="h1" variant="title1">
            {subtitle && (
              <Text
                as="span"
                variant="subtitle1"
                mb={[1, 2]}
                sx={{ display: 'block' }}
              >
                {subtitle}
              </Text>
            )}
            {title}
          </Heading>
        </Box>
        <Grid
          columns={[1, 12]}
          mt={[3, 5, 7]}
          mx={['auto', '0']}
          sx={{
            alignItems: [null, 'center'],
            maxWidth: ['440px', 'none'],
            textAlign: ['center', 'left'],
          }}
        >
          <Box px={[null, null, null, 3]} sx={{ gridColumn: [null, '1 / 7'] }}>
            <GatsbyImage
              image={image.gatsbyImageData}
              alt={image.description}
              loading="eager"
            />
          </Box>
          <Box sx={{ gridColumn: [null, '7 / -1', null, '7 / 12'] }}>
            {description && (
              <Box
                variant="text.body1"
                sx={{
                  p: {
                    m: 0,
                  },
                  a: {
                    variant: 'text.link',
                  },
                }}
                dangerouslySetInnerHTML={{
                  __html: description.childMarkdownRemark.html,
                }}
              />
            )}
            {cta && <Box mt={[2, 3]}>{cta}</Box>}
            {footer && (
              <Box
                variant="text.body2"
                mt={[4, null, null, 5]}
                sx={{
                  p: {
                    m: 0,
                  },
                  a: {
                    variant: 'text.link',
                  },
                }}
                dangerouslySetInnerHTML={{
                  __html: footer.childMarkdownRemark.html,
                }}
              />
            )}
          </Box>
        </Grid>
      </Container>
    </Box>
  )
}

PageHeadingImageSection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.shape({
    description: PropTypes.string,
  }),
  cta: PropTypes.shape({}),
}

export default PageHeadingImageSection
